<template>
  <v-tab-item v-bind="$attrs">
    <v-overlay :value="isLoading" />
    <div class="square-scrolling-container" id="tab">
      <vue-loadmore ref="list"
                    :style="`--distance: ${loadDataset.distance * -2}deg`"
                    :class="loadDataset.status"
                    :on-refresh="onRefresh"
                    :on-loadmore="onLoad"
                    :finished="finished"
                    :show-success-text="false"
                    pull-distance="150"
                    pulling-text="리스트 새로고침"
                    loosing-text="리스트 새로고침"
                    refresh-text="새로고침중"
                    loading-text="로딩중"
                    finished-text="목록의 마지막입니다"
                    error-text="목록을 불러 올 수 없습니다"
      >
        <div class="no-data" v-if="!isLoading && list.length === 0">
          <div class="no-data-text">
            소감글이 없습니다.<br />
            미션 완료 후, 광장에 남겨보세요!
          </div>
        </div>
        <SquareItem v-for="(item, index) in list"
                    :item="item"
                    :index="index"
                    :key="index"
                    @onEvent="onEvent" />
      </vue-loadmore>
    </div>
    <!-- 메뉴모달 -->
    <SquareMenuModal ref="SquareMenuModal" @onEvent="onEvent" />
    <!-- 댓글 -->
    <CommentSheet ref="CommentSheet" @onEvent="onEvent" />
    <!-- 게시글 신고하기 -->
    <ReportingPostssSheet ref="ReportingPostssSheet" @onEvent="onEvent" />
    <!-- 수정하기 모달-->
    <SquareEditModal ref="SquareEditModal" @onEvent="onEvent" />
  </v-tab-item>
</template>

<script>
import store from '@/store'
import Util from '@/utils/utils'
import {mixinAuth, mixinSquare, mixinReward} from '@/mixins'
import SquareItem from './SquareItem'
import SquareEditModal from './SquareEditModal'
import SquareMenuModal from './SquareMenuModal'
import ReportingPostssSheet from '@/components/layout/bottomSheet/ReportingPostssSheet'
import CommentSheet from '@/components/layout/bottomSheet/CommentSheet'

export default {
  name: 'SquareList',
  components: {
    SquareItem,
    CommentSheet,
    ReportingPostssSheet,
    SquareMenuModal,
    SquareEditModal
  },
  mixins: [ mixinAuth, mixinSquare, mixinReward ],
  props: {
    isMySquare: Boolean,
    show: Boolean
  },
  data: () => ({
    page: 0,
    size: 10,
    paging: {
      totalElements: 0,
      totalPages: 1
    },
    finished: false,
    isLoading: false,
    loadDataset: {
      status: 'normal',
      distance: 0,
      duration: 0,
      scroller: null,
      loadLoading: false
    },
    list: []
  }),
  computed: {},
  watch: {
    show: {
      immediate: true,
      handler (nV) {
        if (nV && this.list.length === 0) {
          this.getList()
        } else {
          this.getList(0, this.list.length)
        }
      }
    }
  },
  created () {},
  mounted () {},
  updated () {
    if (this.$refs.list) {
      this.$watch(() => {
        return this.$refs.list.status
      }, () => {
        this.loadDataset = this.$refs.list.$data
      })
    }
  },
  methods: {
    onEvent (value) {
      this[value.fn](value)
    },

    // 메뉴 여/닫기
    menuModalOpen (value) {
      this.$refs.SquareMenuModal.open(value)
    },
    menuModalClose() {
      this.$refs.SquareMenuModal.close()
    },

    // 수정 모달 열기 구분
    editModalOpen (value) {
      let gubun = value.gubun
      if (gubun === 'regi') { // 광장 글 수정
        this.$refs.SquareEditModal.open(value)
      } else if (gubun === 'post') { // 신고하기
        this.$refs.ReportingPostssSheet.open(value)
      } else { // 댓글
        this.$refs.CommentSheet.editModeSetting(value)
      }
    },

    editUnit(value) {
      this.updateSquare(value)
    },
    deleteGubun(value) {
      if (value.gubun === 'regi') {
        this.deleteSquare(value)
      } else {
        this.deleteUnit(value)
      }
    },

    // 리스트
    onRefresh (done) {
      this.list = []
      this.page = 0
      this.finished = false
      this.getList()
      done()
    },
    onLoad (done) {
      if (!this.finished) {
        this.page++
        this.getList()
      }
      done()
    },
    async getList (page = this.page, size = this.size) {

      let params = [
        { page: page },
        { size: size }
      ]
      let squareUrl = 'getSquareList' // 전체 리스트
      if (this.isMySquare) squareUrl = 'getSquareMyList' // 내가 쓴 글

      this.isLoading = true
      await store.dispatch(squareUrl, this.$_payload('ba', params))
        .then(res => {
          if (res.success) {
            let result = res.data.content
            this.paging = {
              totalElements: res.data.totalElements,
              totalPages: res.data.totalPages
            }
            if (result.length === 0) {
              this.finished = this.list.length > 0
            } else {
              if (this.page > 0) {
                this.list.push(...result)
              } else {
                this.list = result
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    // 댓글 상세
    goCmntList (value) {
      // this.pId = squareNo;
      // 해당 형식으로 자식요소 method 호출
      this.$refs.CommentSheet.open(value)
    },

    // 댓글 등록
    addCmntList (value) {
      //TODO 댓글 열릴 때 마다 리스트에 cmntCnt 갱신
      this.$set(this.list[value.index], 'cmntCnt', value.item.cmntCnt)
    },

    // 좋아요
    async likeClick (value) {
      let params = null
      let praisesUrl = null
      let MemberBadgePoss = null
      let index = value.index
      let squareNo = value.item.squareNo
      let isLike = value.item.isPraise === 'Y'

      if (isLike) { // 좋아요 삭제
        params = [
          { squareNo: squareNo },
          { memberNo: this.userKey }
        ]
        praisesUrl = 'setDeleteByPraises'
        MemberBadgePoss = 'deleteMemberBadgePoss'
      } else { // 좋아요 등록
        params = {
          squareNo: squareNo,
          memberNo: this.userKey
        }
        praisesUrl = 'setByPraisesRegist'
        MemberBadgePoss = 'insertMemberBadgePoss'
      }

      await store.dispatch(praisesUrl, this.$_payload('ba', params))
        .then(res => {
          if (res.success) {
            console.log(res)
            // TODO return 값 필요 - detail 조회해서 카운커 가져 오는 상태
            this.getSquareDetail(squareNo, index)
            // 뱃지획득 조회
            this[MemberBadgePoss](1, 1)
          } else {
            console.error(res)
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
        })
    },
    async updateSquare(value) {
      let params = {
        squareNo: value.item.squareNo,
        content: value.inputVal
      }
      await store.dispatch('setSquarePostModify', this.$_payload({'squareNo': params.squareNo}, params))
        .then(res => {
          if (res.success) {
            // 성공
            this.$set(this.list[value.index], 'content', value.inputVal)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    async deleteSquare(value) {
      await store.dispatch('setSquarePostDelete', this.$_payload({'squareNo': value.deleteNo}))
        .then(res => {
          if (res.success) {
            this.$delete(this.list, value.index)
            this.menuModalClose()
          } else {
            console.log(res.msg);
            // this.deleteResult = '';
          }
        })
        .catch(error => {
          console.error(error);
          // this.deleteResult = '';
        })
        .finally(() => {
        })
    },
    async deleteUnit(value) {
      await store.dispatch('setDeleteCmnt', this.$_payload({'cmntNo': value.deleteNo}))
        .then(res => {
          if (res.success) {
            this.$refs.CommentSheet.readList(value.squareNo)
            // this.menuModalClose();
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    unitDetails(value) {
      // 날짜 포맷 변환
      const reg = Util.Date.toFormatDate(value.item.regDt, 'YYYYMMDD')

      // 작성자만 유닛팝업 노출
      if (value.item.regUserKey === this.userKey) {
        // this.$refs.SolutionContainerModal.open(value.item.unitUseNo, reg)
        let unitUseNo = value.item.freeYn == 'Y' ? value.item.unitId : value.item.sltUnitMappingUseNo
        this.$emit('openInSquare', unitUseNo, value.item.freeYn, reg)
      }
    },
    readMore(value) {
      let more = (value.item.more && value.item.more !== undefined) ? false : true
      this.$set(this.list[value.index], 'more', more)
    },

    // TODO 호출 될때마다 리스트 정보 갱신함 (좋아요)
    async getSquareDetail (squareNo, index) {
      await store.dispatch('getSquareOne', this.$_payload({'squareNo': squareNo}))
        .then(res => {
          if (res.success) {
            console.log(res)
            // TODO isPraise 값이 정상 적으로 넘어오면 갱신 데이터로 맞춰 넣을 것
            let isPraise = (this.list[index]['isPraise'] === 'Y') ? 'N' : 'Y'
            this.$set(this.list[index], 'isPraise', isPraise)
            this.$set(this.list[index], 'praiseCnt', res.data.praiseCnt)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    }
  }
}
</script>
